const images = {
    noImage: require('~/assets/images/no-image.png'),
    defaultAvatar: require('~/assets/images/default-avatar.png'),
    errorBackground: require('~/assets/images/error-background.png'),
    illustration: require('~/assets/images/Illustration.svg').default,
};

export default images;
